import HeaderBar from "../../../components/header/headerBar";
import { Input, Textarea } from "../../../components/textfield";
import { mdiMinusCircle, mdiPlusCircle, mdiCheckCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import SelectField from "../../../components/select/selectField";
import EmptyModel from "../../../components/modal/emptyModal";
import MainButton from "../../../components/button/mainButton";
import { numberWithCommas } from "../../../helpers/functions";
import { useParams, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  Select,
  Row,
  Col,
  Alert,
  message,
  Form,
  Checkbox,
  DatePicker,
} from "antd";
import axios from "axios";
import { number } from "prop-types";
interface ParamTypes {
  id: string;
}

const PaymentRecord = () => {
  const { Option } = Select;
  const history = useHistory();
  const [dataSO, setDataSO] = useState<any>({});
  const [description, setDescription] = useState<string>("");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [amountPayment, setAmountPayMent] = useState<string>("");
  const [amountSpace, setAmountSpace] = useState<string>("");
  const [amountPaid, setAmountPaid] = useState<string>("");
  const [typePayment, setTypePayMent] = useState<string>("");

  const [modalForm, setModalForm] = useState<any>({});

  const [paymentType, setPaymentType] = useState<any>([]);
  const [paymentGetList, setPaymentGetList] = useState<any>([]);
  const [paymentList, setPaymentList] = useState<any>([]);
  const [paymentFormSelect, setPaymentFormSelect] = useState<string>("");
  const paymentForm = {
    paymentType: "632179d05e30ed4dfebf50c8",
    paymentName: "",
    paymentAmount: 0,
    paymentPayIN: "",
    paymentDate: "",
    paymentDetail: "",
  };
  const [changePayment, setChangePayMent] = useState<any>([
    {
      amountDetail: [],
    },
  ]);
  const { id } = useParams<ParamTypes>();

  const getAPIs = () => {
    setDescription("ชำระด้วยเงินสด  วันที่ 18-01-2021");
    setAmountPayMent("17,510.00");
    setAmountPaid("17,510.00");
    setAmountSpace("");
    setTypePayMent("cash2");
  };

  const onChangePayPaid = () => {
    console.log("PAY MENT CAHIER =>");
    setPaymentList([...paymentList, paymentForm]);
  };

  const removepayment = (item: any, index: any) => {
    console.log("REMOVE PAY MENT CAHIER =>");
    paymentList.splice(index, 1);
    setPaymentList([...paymentList]);
  };

  useEffect(() => {
    getAPIs();
  }, []);

  useEffect(() => {
    axios.get(`/so/get-so?soId=${id}`).then((res) => {
      setDataSO(res?.data);
    });

    axios.get(`/payments/type`).then((res) => {
      const { data } = res;
      setPaymentType(
        data.map((item: any, index: number) => {
          return {
            name: item.name,
            value: item._id,
          };
        })
      );
    });
    axios.get(`/payments`).then((res) => {
      const { data } = res;
      setPaymentGetList(data);
    });

    setPaymentList([...paymentList, paymentForm]);
  }, [id]);

  const isPaymentType = (value: any, index: number) => {
    paymentList[index]["paymentType"] = value;
    setPaymentList([...paymentList]);
  };

  const FindPaymentName = (item: any) => {
    const data = paymentGetList.filter(
      (i: any) => i.type === item.paymentType && i.format === "payment"
    );
    return data.length > 0
      ? data.map((l: any, index: number) => {
        return {
          name: l.name,
          value: l._id,
        };
      })
      : [];
  };

  const paymentRecord = () => {
    axios
      .post(`/payments/record`, {
        soId: id,
        paymentFormSelect,
        paymentrecord: paymentList,
      })
      .then((res) => {
        if (res.status === 200) {
          setIsOpen(true);
          setModalForm(res?.data);
          setTimeout(() => {
            history.push("/cashier");
          }, 2500);
        }
        console.log(res);
      })
      .catch((e) => {
        if (e.response) {
          message.error(e.response.data.error.message);
        }
      });
  };
  const NumberFormat = (number: number = 0) => {
    try {
      let str_number = number.toFixed(2)
      let split_number = str_number.split(".")
      return new Intl.NumberFormat().format(number) + `.${split_number[1]}`;
    } catch (error) {
      let str = number.toString();
      let str_number = parseFloat(str).toFixed(2)
      let split_number = str_number.split(".")
      return new Intl.NumberFormat().format(split_number.length > 0 ? parseFloat(split_number[0]) : number) + `.${split_number[1]}`;
    }
    // return new Intl.NumberFormat().format(number)
  }
  return (
    <div>
      <HeaderBar title="CASHIER/Payment Record" btnBack />
      <EmptyModel show={isOpen} btnClose={false} width="650px">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <div className="row justify-center">
            <Icon path={mdiCheckCircleOutline} color="#86CFC6" size="120" />
          </div>

          <div className="row justify-center  mt-20">
            <div
              style={{
                padding: 0,
                marginBottom: 5,
                fontSize: 16,
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              บันทึกเรียบร้อยแล้ว/Recorded Successfully.
            </div>
            <div
              style={{
                padding: 0,
                marginBottom: 5,
                fontSize: 16,
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              {paymentFormSelect === "PayDeposit" && (
                <p>ชำระเงินมัดจำ/Pay Deposit</p>
              )}
              <p>
                ยอดเงินที่ชำระ/Payment Amount {modalForm?.paymentAmount}{" "}
                บาท/Baht.
              </p>
              <p>
                มียอดค้างชำระ/Outstanding Balance{" "}
                {modalForm?.outstandingBalance} บาท/Baht.
              </p>
            </div>
          </div>
        </div>
      </EmptyModel>
      <div
        style={{
          backgroundColor: "#fff",
          margin: "40px",
          padding: "40px 20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="row">
          <h5 className="col-12">
            <b>ชำระเงินรายการซื้อคอร์ส/Pay for the course purchase.</b>
          </h5>
          <div className="col-3">
            <div className="input">
              <div
                style={{
                  padding: 0,
                  color: "#5BAEA9",
                  marginBottom: 5,
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                ชำระแบบ/Pay Form
              </div>
              <Form.Item
                name="productCategories"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  onChange={(value: any) => setPaymentFormSelect(value)}
                  style={{ width: "100%" }}
                  filterOption={(input: any, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                    0
                  }
                  defaultValue={paymentFormSelect}
                  showSearch
                >
                  <Option value="PayDeposit">ชำระเงินมัดจำ/Pay Deposit</Option>
                  <Option value="FullPayment">ชำระเต็มจำนวน/Full Payment</Option>
                </Select>
              </Form.Item>
            </div>
          </div>
          <div className="col-3">
            <Input
              title="จำนวนเงินที่ต้องชำระ/Amount to be paid."
              value={dataSO?.outstandingBalance}
              onChange={(e) => {
                setDataSO({ ...dataSO, outstandingBalance: e.target.value })
                // setAmountPaid(e.target.value);
              }}
              inputStyle={{
                borderBottom: "2px solid #d3d8dd",
                padding: "1px 2px"
              }}
              customText={NumberFormat(dataSO?.outstandingBalance)}
            />
          </div>
        </div>
        <div className="row" style={{ marginTop: "60px" }}>
          <h5 className="col-12">
            <b>เลือกช่องทางการชำระเงิน/Choose payment method.</b>
          </h5>
        </div>
        {paymentList.map((item: any, index: number) => (
          <div className="row" style={{ marginTop: "30px" }} key={index}>
            <div style={{ alignItems: "center", display: "flex" }}>
              <div className="col-11" style={{ border: "1px solid #D3D8DD" }}>
                <div
                  className="row"
                  style={{
                    padding: "20px 40px",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="col-3">
                    <div className="input">
                      <div
                        style={{
                          padding: 0,
                          color: "#5BAEA9",
                          marginBottom: 5,
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                      >
                        ประเภทการชำระเงิน/Payment Type
                      </div>
                      <Form.Item
                        name="productCategories"
                        rules={[
                          {
                            required: true,
                            message: "กรุณากรอกข้อมูล!",
                          },
                        ]}
                      >
                        <Select
                          onChange={(value: any) => isPaymentType(value, index)}
                          style={{ width: "100%" }}
                          filterOption={(input: any, option: any) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          defaultValue={item.paymentType}
                          showSearch
                        >
                          <Option value={""}> </Option>
                          {paymentType.map((item: any, index: any) => (
                            <Option value={item.value} key={index}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="input">
                      <div
                        style={{
                          padding: 0,
                          color: "#5BAEA9",
                          marginBottom: 5,
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                      >
                        ชื่อการชำระเงิน/Payment Name
                      </div>
                      <Form.Item
                        name="productCategories"
                        rules={[
                          {
                            required: true,
                            message: "กรุณากรอกข้อมูล!",
                          },
                        ]}
                      >
                        <Select
                          onChange={(value: any) => {
                            paymentList[index]["paymentName"] = value;
                            setPaymentList([...paymentList]);
                          }}
                          style={{ width: "100%" }}
                          filterOption={(input: any, option: any) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          defaultValue={item.paymentName}
                          showSearch
                        >
                          <Option value={""}> </Option>
                          {FindPaymentName(item).map((item: any, index: any) => (
                            <Option value={item.value} key={index}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-3">
                    {/* <Input
                      title="เลขที่บัตร/Card Number"
                      value={item.paymentAmount}
                      disabled
                    /> */}
                  </div>
                  <div className="col-3">
                  {/* <Input
                      title="ประเภทบัตร/Card Type"
                      value={item.paymentAmount}
                    /> */}
                  </div>
                </div>
                <div
                  className="row"
                  style={{
                    padding: "20px 40px",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="col-3">
                    <Input
                      title="จำนวนเงินที่ชำระเงิน/Payment Amount"
                      value={item.paymentAmount}
                      onChange={(e) => {
                        const { value } = e.target;
                        paymentList[index]["paymentAmount"] = value;
                        setPaymentList([...paymentList]);
                      }}
                      inputStyle={{
                        borderBottom: "2px solid #d3d8dd",
                        padding: "1px 2px"
                      }}
                      customText={NumberFormat(item?.paymentAmount)}
                    />
                  </div>
                  <div className="col-3">
                    <div className="input">
                      <div
                        style={{
                          padding: 0,
                          color: "#5BAEA9",
                          marginBottom: 5,
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                      >
                        จ่ายเงินที่/Pay IN
                      </div>
                      <Form.Item
                        name="productCategories"
                        rules={[
                          {
                            required: true,
                            message: "กรุณากรอกข้อมูล!",
                          },
                        ]}
                      >
                        <Select
                          onChange={(value: any) => {
                            paymentList[index]["paymentPayIN"] = value;
                            setPaymentList([...paymentList]);
                          }}
                          style={{ width: "100%" }}
                          filterOption={(input: any, option: any) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          defaultValue={item.paymentPayIN}
                          showSearch
                        >
                          <Option value={""}> </Option>
                          {paymentGetList
                            .filter((i: any) => i.format === "payin" && i.type === item.paymentType)
                            .map((item: any, index: number) => {
                              return {
                                name: item.name,
                                value: item._id,
                              };
                            })
                            .map((item: any, index: any) => (
                              <Option value={item.value} key={index}>
                                {item.name}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="heading">
                      <p>วันที่ชำระ/Payment Date</p>
                    </div>
                    <Form.Item
                      name="startDate"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <DatePicker
                        placeholder="mm/dd/yyyy"
                        format="DD-MM-YYYY"
                        style={{
                          height: "auto",
                          width: "100%",
                          border: "none",
                          borderRadius: "0px",
                          borderBottom: "2px solid #d9d9d9",
                        }}
                        onChange={(e: any) => {
                          paymentList[index]["paymentDate"] = e.format();
                          setPaymentList([...paymentList]);
                        }}
                      />
                    </Form.Item>
                  </div>
                  <Input
                    className="col-3"
                    title="รายละเอียด/Payment Details"
                    value={item.paymentDetail}
                    onChange={(e) => {
                      const { value } = e.target;
                      paymentList[index]["paymentDetail"] = e.target.value;
                      setPaymentList([...paymentList]);
                    }}
                  />
                </div>
              </div>
              <div
                className="col-1"
                style={{ textAlign: "center", cursor: "pointer" }}
                onClick={() => removepayment(item, index)}
              >
                <Icon path={mdiMinusCircle} size="25" color="#E76464" />
              </div>
            </div>
          </div>
        ))}
        <div
          className="mt-20"
          style={{ alignItems: "center", display: "flex" }}
        >
          <div className="col-11" style={{ border: "1px solid #D3D8DD" }}>
            <div
              className="row"
              style={{ padding: "20px 40px", justifyContent: "space-between" }}
            >
              เพิ่มการชำระเงิน
            </div>
          </div>
          <div
            className="col-1"
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => onChangePayPaid()}
          >
            <Icon path={mdiPlusCircle} size="25" color="#4D7E7F" />
          </div>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <MainButton
          title="บันทึกการชำระเงิน/
Payment Record"
          background="#4D7E7F"
          onClick={() => paymentRecord()}
        />
      </div>
    </div>
  );
};
export default PaymentRecord;
